import React from 'react';
export function LiveIndicator() {
  return <div className="flex items-center gap-2 bg-red-900/30 px-3 py-1 rounded-full" data-id="element-97">
      <div className="relative" data-id="element-98">
        <div className="absolute inset-0 bg-red-600 rounded-full animate-ping opacity-75" data-id="element-99"></div>
        <div className="relative w-3 h-3 bg-red-600 rounded-full" data-id="element-100"></div>
      </div>
      <span className="font-bold text-sm uppercase" data-id="element-101">Live</span>
    </div>;
}